import React from 'react'
import { useEffect } from 'react'
import styled from 'styled-components'
import { PageHero,ProductList } from '../components'
import { useParams} from 'react-router-dom'
import { useFilterContext } from '../context/filter_context'
import GridView from '../components/GridView'



const Specials = () => {
  const {title} = useParams();
  
  const {getSpecial,filtered_specials} = useFilterContext()

  console.log(title);

  useEffect(()=>{
    getSpecial(title)
  },[title])

  


    return (
        <main>
            <PageHero title='Specials'/>
            <Wrapper className='page'>
             
            {filtered_specials? 
              <div>
                <div className='section-center products'>
                  <GridView products={filtered_specials}/>
                </div>     

              </div> : <h2>Sorry no specials to show...</h2>}               
                
            
            </Wrapper>

        </main>
        
    )
}

const Wrapper = styled.div`
  .products {
    display: grid;
    gap: 3rem 1.5rem;
    margin: 4rem auto;
  }
  @media (min-width: 768px) {
    .products {
      grid-template-columns: 200px 1fr;
    }
  }
`

export default Specials
